import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type {
    IUseRemoveWorkOrderObjectProps,
    IUseRemoveWorkOrderObjectResult,
} from 'pages/Project/Common/WorkOrderStructure/types';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerRemoveWorkOrderObjectGql } from '../../workOrderQueries';

const requestId = 'uerRemoveWorkOrderObject';

export const useUerRemoveWorkOrderObject = (props: IUseRemoveWorkOrderObjectProps): IUseRemoveWorkOrderObjectResult => {
    const dispatch = useDispatch();
    const { onSuccess, workOrderOrChangeId } = props;

    const [uerRemoveWorkOrderObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerRemoveWorkOrderObjectReset(undefined);
        onSuccess?.();
    }, [uerRemoveWorkOrderObjectReset, onSuccess]);

    const [, uerRemoveWorkOrderObjectStatus, , uerRemoveWorkOrderObjectRequest] = useRequest({
        requestId,
        query: uerRemoveWorkOrderObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerRemoveWorkOrderObjectMakeRequest = useCallback(
        (contractObjectId: number) => {
            dispatch(uerRemoveWorkOrderObjectRequest({ workOrderId: workOrderOrChangeId, contractObjectId }));
        },
        [uerRemoveWorkOrderObjectRequest, dispatch, workOrderOrChangeId],
    );

    useEffect(() => {
        uerRemoveWorkOrderObjectReset(undefined);
    }, [uerRemoveWorkOrderObjectReset]);

    return {
        status: uerRemoveWorkOrderObjectStatus,
        makeRequest: uerRemoveWorkOrderObjectMakeRequest,
    };
};
